exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-form.input-text {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  .input-form.input-text label {\n    font-size: 13px; }\n  .input-form.input-text input {\n    padding: 10px 30px 5px 10px; }\n  .input-form.input-text .glyphicon {\n    position: absolute;\n    top: 50%;\n    right: 5px;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%);\n    padding: 5px;\n    color: #00afd2;\n    cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/shared/sacyr-input/sacyr-input.component.scss
// module id = ../../../../../src/app/shared/sacyr-input/sacyr-input.component.scss
// module chunks = main